import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "grpc/edox/access/access_api.proto" (package "grpc.edox.access", syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "grpc/edox/access/access_api.proto" (package "grpc.edox.access", syntax proto3)
// tslint:disable
import { Empty } from "@finam/tx-proto-lib-google-wellknown/google/protobuf/empty_pb";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "@finam/tx-proto-lib-google-wellknown/google/protobuf/timestamp_pb";
import { UserAccount } from "../../../proto/edox/access/access_pb";
import { PersonalData } from "../../../proto/edox/access/access_pb";
import { UserAccountInfo } from "../../../proto/edox/access/access_pb";
import { PassportType } from "../../../proto/edox/access/access_pb";
import { Date } from "@finam/tx-proto-grpc-proto/google/type/date_pb";
import { PassportId } from "../../../proto/edox/access/access_pb";
/**
 * @generated from protobuf enum grpc.edox.access.CheckRegistrationRequest.Gender
 */

export var CheckRegistrationRequest_Gender;

(function (CheckRegistrationRequest_Gender) {
  /**
   * @generated from protobuf enum value: UNKNOWN = 0;
   */
  CheckRegistrationRequest_Gender[CheckRegistrationRequest_Gender["UNKNOWN"] = 0] = "UNKNOWN";
  /**
   * @generated from protobuf enum value: MALE = 1;
   */

  CheckRegistrationRequest_Gender[CheckRegistrationRequest_Gender["MALE"] = 1] = "MALE";
  /**
   * @generated from protobuf enum value: FEMALE = 2;
   */

  CheckRegistrationRequest_Gender[CheckRegistrationRequest_Gender["FEMALE"] = 2] = "FEMALE";
})(CheckRegistrationRequest_Gender || (CheckRegistrationRequest_Gender = {}));
/**
 * @generated from protobuf enum grpc.edox.access.RegistrationRequest.Gender
 */


export var RegistrationRequest_Gender;

(function (RegistrationRequest_Gender) {
  /**
   * @generated from protobuf enum value: UNKNOWN = 0;
   */
  RegistrationRequest_Gender[RegistrationRequest_Gender["UNKNOWN"] = 0] = "UNKNOWN";
  /**
   * @generated from protobuf enum value: MALE = 1;
   */

  RegistrationRequest_Gender[RegistrationRequest_Gender["MALE"] = 1] = "MALE";
  /**
   * @generated from protobuf enum value: FEMALE = 2;
   */

  RegistrationRequest_Gender[RegistrationRequest_Gender["FEMALE"] = 2] = "FEMALE";
})(RegistrationRequest_Gender || (RegistrationRequest_Gender = {})); // @generated message type with reflection information, may provide speed optimized methods


var GetRegistrationInfoRequest$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(GetRegistrationInfoRequest$Type, _MessageType);

  var _super = _createSuper(GetRegistrationInfoRequest$Type);

  function GetRegistrationInfoRequest$Type() {
    _classCallCheck(this, GetRegistrationInfoRequest$Type);

    return _super.call(this, "grpc.edox.access.GetRegistrationInfoRequest", [{
      no: 1,
      name: "first_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "last_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "middle_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "passport_id",
      kind: "message",
      T: function T() {
        return PassportId;
      }
    }, {
      no: 5,
      name: "date_of_birth",
      kind: "message",
      T: function T() {
        return Date;
      }
    }, {
      no: 6,
      name: "passport_type",
      kind: "enum",
      T: function T() {
        return ["proto.edox.access.PassportType", PassportType];
      }
    }]);
  }

  _createClass(GetRegistrationInfoRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        firstName: "",
        lastName: "",
        middleName: "",
        passportType: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* string first_name */
          1:
            message.firstName = reader.string();
            break;

          case
          /* string last_name */
          2:
            message.lastName = reader.string();
            break;

          case
          /* string middle_name */
          3:
            message.middleName = reader.string();
            break;

          case
          /* proto.edox.access.PassportId passport_id */
          4:
            message.passportId = PassportId.internalBinaryRead(reader, reader.uint32(), options, message.passportId);
            break;

          case
          /* google.type.Date date_of_birth */
          5:
            message.dateOfBirth = Date.internalBinaryRead(reader, reader.uint32(), options, message.dateOfBirth);
            break;

          case
          /* proto.edox.access.PassportType passport_type */
          6:
            message.passportType = reader.int32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string first_name = 1; */
      if (message.firstName !== "") writer.tag(1, WireType.LengthDelimited).string(message.firstName);
      /* string last_name = 2; */

      if (message.lastName !== "") writer.tag(2, WireType.LengthDelimited).string(message.lastName);
      /* string middle_name = 3; */

      if (message.middleName !== "") writer.tag(3, WireType.LengthDelimited).string(message.middleName);
      /* proto.edox.access.PassportId passport_id = 4; */

      if (message.passportId) PassportId.internalBinaryWrite(message.passportId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      /* google.type.Date date_of_birth = 5; */

      if (message.dateOfBirth) Date.internalBinaryWrite(message.dateOfBirth, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
      /* proto.edox.access.PassportType passport_type = 6; */

      if (message.passportType !== 0) writer.tag(6, WireType.Varint).int32(message.passportType);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetRegistrationInfoRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.GetRegistrationInfoRequest
 */


export var GetRegistrationInfoRequest = new GetRegistrationInfoRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RegistrationInfo$Type = /*#__PURE__*/function (_MessageType2) {
  _inherits(RegistrationInfo$Type, _MessageType2);

  var _super2 = _createSuper(RegistrationInfo$Type);

  function RegistrationInfo$Type() {
    _classCallCheck(this, RegistrationInfo$Type);

    return _super2.call(this, "grpc.edox.access.RegistrationInfo", [{
      no: 1,
      name: "user_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "masked_phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "masked_email",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "authentication_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }]);
  }

  _createClass(RegistrationInfo$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        userId: "",
        maskedPhone: "",
        maskedEmail: "",
        authenticationId: "0"
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag3 = reader.tag(),
            _reader$tag4 = _slicedToArray(_reader$tag3, 2),
            fieldNo = _reader$tag4[0],
            wireType = _reader$tag4[1];

        switch (fieldNo) {
          case
          /* string user_id = 1 [deprecated = true];*/
          1:
            message.userId = reader.string();
            break;

          case
          /* string masked_phone */
          2:
            message.maskedPhone = reader.string();
            break;

          case
          /* string masked_email */
          3:
            message.maskedEmail = reader.string();
            break;

          case
          /* uint64 authentication_id */
          4:
            message.authenticationId = reader.uint64().toString();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string user_id = 1 [deprecated = true]; */
      if (message.userId !== "") writer.tag(1, WireType.LengthDelimited).string(message.userId);
      /* string masked_phone = 2; */

      if (message.maskedPhone !== "") writer.tag(2, WireType.LengthDelimited).string(message.maskedPhone);
      /* string masked_email = 3; */

      if (message.maskedEmail !== "") writer.tag(3, WireType.LengthDelimited).string(message.maskedEmail);
      /* uint64 authentication_id = 4; */

      if (message.authenticationId !== "0") writer.tag(4, WireType.Varint).uint64(message.authenticationId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RegistrationInfo$Type;
}(MessageType);
/**
 * @deprecated
 * @generated MessageType for protobuf message grpc.edox.access.RegistrationInfo
 */


export var RegistrationInfo = new RegistrationInfo$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetRegistrationInfoResponse$Type = /*#__PURE__*/function (_MessageType3) {
  _inherits(GetRegistrationInfoResponse$Type, _MessageType3);

  var _super3 = _createSuper(GetRegistrationInfoResponse$Type);

  function GetRegistrationInfoResponse$Type() {
    _classCallCheck(this, GetRegistrationInfoResponse$Type);

    return _super3.call(this, "grpc.edox.access.GetRegistrationInfoResponse", [{
      no: 1,
      name: "user_account_info",
      kind: "message",
      T: function T() {
        return UserAccountInfo;
      }
    }]);
  }

  _createClass(GetRegistrationInfoResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag5 = reader.tag(),
            _reader$tag6 = _slicedToArray(_reader$tag5, 2),
            fieldNo = _reader$tag6[0],
            wireType = _reader$tag6[1];

        switch (fieldNo) {
          case
          /* proto.edox.access.UserAccountInfo user_account_info */
          1:
            message.userAccountInfo = UserAccountInfo.internalBinaryRead(reader, reader.uint32(), options, message.userAccountInfo);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.edox.access.UserAccountInfo user_account_info = 1; */
      if (message.userAccountInfo) UserAccountInfo.internalBinaryWrite(message.userAccountInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetRegistrationInfoResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.GetRegistrationInfoResponse
 */


export var GetRegistrationInfoResponse = new GetRegistrationInfoResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var CheckRegistrationRequest$Type = /*#__PURE__*/function (_MessageType4) {
  _inherits(CheckRegistrationRequest$Type, _MessageType4);

  var _super4 = _createSuper(CheckRegistrationRequest$Type);

  function CheckRegistrationRequest$Type() {
    _classCallCheck(this, CheckRegistrationRequest$Type);

    return _super4.call(this, "grpc.edox.access.CheckRegistrationRequest", [{
      no: 1,
      name: "phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "first_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "last_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "middle_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 5,
      name: "date_of_birth",
      kind: "message",
      T: function T() {
        return Date;
      }
    }, {
      no: 6,
      name: "gender",
      kind: "enum",
      T: function T() {
        return ["grpc.edox.access.CheckRegistrationRequest.Gender", CheckRegistrationRequest_Gender];
      }
    }, {
      no: 7,
      name: "email",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 8,
      name: "personal_data",
      kind: "message",
      T: function T() {
        return PersonalData;
      }
    }]);
  }

  _createClass(CheckRegistrationRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        phone: "",
        firstName: "",
        lastName: "",
        middleName: "",
        gender: 0,
        email: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag7 = reader.tag(),
            _reader$tag8 = _slicedToArray(_reader$tag7, 2),
            fieldNo = _reader$tag8[0],
            wireType = _reader$tag8[1];

        switch (fieldNo) {
          case
          /* string phone */
          1:
            message.phone = reader.string();
            break;

          case
          /* string first_name = 2 [deprecated = true];*/
          2:
            message.firstName = reader.string();
            break;

          case
          /* string last_name = 3 [deprecated = true];*/
          3:
            message.lastName = reader.string();
            break;

          case
          /* string middle_name = 4 [deprecated = true];*/
          4:
            message.middleName = reader.string();
            break;

          case
          /* google.type.Date date_of_birth = 5 [deprecated = true];*/
          5:
            message.dateOfBirth = Date.internalBinaryRead(reader, reader.uint32(), options, message.dateOfBirth);
            break;

          case
          /* grpc.edox.access.CheckRegistrationRequest.Gender gender = 6 [deprecated = true];*/
          6:
            message.gender = reader.int32();
            break;

          case
          /* string email */
          7:
            message.email = reader.string();
            break;

          case
          /* proto.edox.access.PersonalData personal_data */
          8:
            message.personalData = PersonalData.internalBinaryRead(reader, reader.uint32(), options, message.personalData);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string phone = 1; */
      if (message.phone !== "") writer.tag(1, WireType.LengthDelimited).string(message.phone);
      /* string first_name = 2 [deprecated = true]; */

      if (message.firstName !== "") writer.tag(2, WireType.LengthDelimited).string(message.firstName);
      /* string last_name = 3 [deprecated = true]; */

      if (message.lastName !== "") writer.tag(3, WireType.LengthDelimited).string(message.lastName);
      /* string middle_name = 4 [deprecated = true]; */

      if (message.middleName !== "") writer.tag(4, WireType.LengthDelimited).string(message.middleName);
      /* google.type.Date date_of_birth = 5 [deprecated = true]; */

      if (message.dateOfBirth) Date.internalBinaryWrite(message.dateOfBirth, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
      /* grpc.edox.access.CheckRegistrationRequest.Gender gender = 6 [deprecated = true]; */

      if (message.gender !== 0) writer.tag(6, WireType.Varint).int32(message.gender);
      /* string email = 7; */

      if (message.email !== "") writer.tag(7, WireType.LengthDelimited).string(message.email);
      /* proto.edox.access.PersonalData personal_data = 8; */

      if (message.personalData) PersonalData.internalBinaryWrite(message.personalData, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return CheckRegistrationRequest$Type;
}(MessageType);
/**
 * @deprecated
 * @generated MessageType for protobuf message grpc.edox.access.CheckRegistrationRequest
 */


export var CheckRegistrationRequest = new CheckRegistrationRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var CheckRegistrationResponse$Type = /*#__PURE__*/function (_MessageType5) {
  _inherits(CheckRegistrationResponse$Type, _MessageType5);

  var _super5 = _createSuper(CheckRegistrationResponse$Type);

  function CheckRegistrationResponse$Type() {
    _classCallCheck(this, CheckRegistrationResponse$Type);

    return _super5.call(this, "grpc.edox.access.CheckRegistrationResponse", [{
      no: 1,
      name: "login",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(CheckRegistrationResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        login: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag9 = reader.tag(),
            _reader$tag10 = _slicedToArray(_reader$tag9, 2),
            fieldNo = _reader$tag10[0],
            wireType = _reader$tag10[1];

        switch (fieldNo) {
          case
          /* string login */
          1:
            message.login = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string login = 1; */
      if (message.login !== "") writer.tag(1, WireType.LengthDelimited).string(message.login);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return CheckRegistrationResponse$Type;
}(MessageType);
/**
 * @deprecated
 * @generated MessageType for protobuf message grpc.edox.access.CheckRegistrationResponse
 */


export var CheckRegistrationResponse = new CheckRegistrationResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var CheckAccountRegistrationRequest$Type = /*#__PURE__*/function (_MessageType6) {
  _inherits(CheckAccountRegistrationRequest$Type, _MessageType6);

  var _super6 = _createSuper(CheckAccountRegistrationRequest$Type);

  function CheckAccountRegistrationRequest$Type() {
    _classCallCheck(this, CheckAccountRegistrationRequest$Type);

    return _super6.call(this, "grpc.edox.access.CheckAccountRegistrationRequest", [{
      no: 1,
      name: "phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "email",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "personal_data",
      kind: "message",
      T: function T() {
        return PersonalData;
      }
    }, {
      no: 4,
      name: "citizenship_country_id",
      kind: "scalar",
      T: 13
      /*ScalarType.UINT32*/

    }]);
  }

  _createClass(CheckAccountRegistrationRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        phone: "",
        email: "",
        citizenshipCountryId: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag11 = reader.tag(),
            _reader$tag12 = _slicedToArray(_reader$tag11, 2),
            fieldNo = _reader$tag12[0],
            wireType = _reader$tag12[1];

        switch (fieldNo) {
          case
          /* string phone */
          1:
            message.phone = reader.string();
            break;

          case
          /* string email */
          2:
            message.email = reader.string();
            break;

          case
          /* proto.edox.access.PersonalData personal_data */
          3:
            message.personalData = PersonalData.internalBinaryRead(reader, reader.uint32(), options, message.personalData);
            break;

          case
          /* uint32 citizenship_country_id */
          4:
            message.citizenshipCountryId = reader.uint32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string phone = 1; */
      if (message.phone !== "") writer.tag(1, WireType.LengthDelimited).string(message.phone);
      /* string email = 2; */

      if (message.email !== "") writer.tag(2, WireType.LengthDelimited).string(message.email);
      /* proto.edox.access.PersonalData personal_data = 3; */

      if (message.personalData) PersonalData.internalBinaryWrite(message.personalData, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
      /* uint32 citizenship_country_id = 4; */

      if (message.citizenshipCountryId !== 0) writer.tag(4, WireType.Varint).uint32(message.citizenshipCountryId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return CheckAccountRegistrationRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.CheckAccountRegistrationRequest
 */


export var CheckAccountRegistrationRequest = new CheckAccountRegistrationRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var CheckAccountRegistrationResponse$Type = /*#__PURE__*/function (_MessageType7) {
  _inherits(CheckAccountRegistrationResponse$Type, _MessageType7);

  var _super7 = _createSuper(CheckAccountRegistrationResponse$Type);

  function CheckAccountRegistrationResponse$Type() {
    _classCallCheck(this, CheckAccountRegistrationResponse$Type);

    return _super7.call(this, "grpc.edox.access.CheckAccountRegistrationResponse", [{
      no: 1,
      name: "account",
      kind: "message",
      T: function T() {
        return UserAccount;
      }
    }, {
      no: 2,
      name: "user_account_info",
      kind: "message",
      T: function T() {
        return UserAccountInfo;
      }
    }]);
  }

  _createClass(CheckAccountRegistrationResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag13 = reader.tag(),
            _reader$tag14 = _slicedToArray(_reader$tag13, 2),
            fieldNo = _reader$tag14[0],
            wireType = _reader$tag14[1];

        switch (fieldNo) {
          case
          /* proto.edox.access.UserAccount account = 1 [deprecated = true];*/
          1:
            message.account = UserAccount.internalBinaryRead(reader, reader.uint32(), options, message.account);
            break;

          case
          /* proto.edox.access.UserAccountInfo user_account_info */
          2:
            message.userAccountInfo = UserAccountInfo.internalBinaryRead(reader, reader.uint32(), options, message.userAccountInfo);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.edox.access.UserAccount account = 1 [deprecated = true]; */
      if (message.account) UserAccount.internalBinaryWrite(message.account, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      /* proto.edox.access.UserAccountInfo user_account_info = 2; */

      if (message.userAccountInfo) UserAccountInfo.internalBinaryWrite(message.userAccountInfo, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return CheckAccountRegistrationResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.CheckAccountRegistrationResponse
 */


export var CheckAccountRegistrationResponse = new CheckAccountRegistrationResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RegistrationRequest$Type = /*#__PURE__*/function (_MessageType8) {
  _inherits(RegistrationRequest$Type, _MessageType8);

  var _super8 = _createSuper(RegistrationRequest$Type);

  function RegistrationRequest$Type() {
    _classCallCheck(this, RegistrationRequest$Type);

    return _super8.call(this, "grpc.edox.access.RegistrationRequest", [{
      no: 1,
      name: "phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "first_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "last_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "middle_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 5,
      name: "date_of_birth",
      kind: "message",
      T: function T() {
        return Date;
      }
    }, {
      no: 6,
      name: "gender",
      kind: "enum",
      T: function T() {
        return ["grpc.edox.access.RegistrationRequest.Gender", RegistrationRequest_Gender];
      }
    }, {
      no: 7,
      name: "email",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 8,
      name: "password",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 9,
      name: "personal_data",
      kind: "message",
      T: function T() {
        return PersonalData;
      }
    }]);
  }

  _createClass(RegistrationRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        phone: "",
        firstName: "",
        lastName: "",
        middleName: "",
        gender: 0,
        email: "",
        password: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag15 = reader.tag(),
            _reader$tag16 = _slicedToArray(_reader$tag15, 2),
            fieldNo = _reader$tag16[0],
            wireType = _reader$tag16[1];

        switch (fieldNo) {
          case
          /* string phone */
          1:
            message.phone = reader.string();
            break;

          case
          /* string first_name = 2 [deprecated = true];*/
          2:
            message.firstName = reader.string();
            break;

          case
          /* string last_name = 3 [deprecated = true];*/
          3:
            message.lastName = reader.string();
            break;

          case
          /* string middle_name = 4 [deprecated = true];*/
          4:
            message.middleName = reader.string();
            break;

          case
          /* google.type.Date date_of_birth = 5 [deprecated = true];*/
          5:
            message.dateOfBirth = Date.internalBinaryRead(reader, reader.uint32(), options, message.dateOfBirth);
            break;

          case
          /* grpc.edox.access.RegistrationRequest.Gender gender = 6 [deprecated = true];*/
          6:
            message.gender = reader.int32();
            break;

          case
          /* string email */
          7:
            message.email = reader.string();
            break;

          case
          /* string password */
          8:
            message.password = reader.string();
            break;

          case
          /* proto.edox.access.PersonalData personal_data */
          9:
            message.personalData = PersonalData.internalBinaryRead(reader, reader.uint32(), options, message.personalData);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string phone = 1; */
      if (message.phone !== "") writer.tag(1, WireType.LengthDelimited).string(message.phone);
      /* string first_name = 2 [deprecated = true]; */

      if (message.firstName !== "") writer.tag(2, WireType.LengthDelimited).string(message.firstName);
      /* string last_name = 3 [deprecated = true]; */

      if (message.lastName !== "") writer.tag(3, WireType.LengthDelimited).string(message.lastName);
      /* string middle_name = 4 [deprecated = true]; */

      if (message.middleName !== "") writer.tag(4, WireType.LengthDelimited).string(message.middleName);
      /* google.type.Date date_of_birth = 5 [deprecated = true]; */

      if (message.dateOfBirth) Date.internalBinaryWrite(message.dateOfBirth, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
      /* grpc.edox.access.RegistrationRequest.Gender gender = 6 [deprecated = true]; */

      if (message.gender !== 0) writer.tag(6, WireType.Varint).int32(message.gender);
      /* string email = 7; */

      if (message.email !== "") writer.tag(7, WireType.LengthDelimited).string(message.email);
      /* string password = 8; */

      if (message.password !== "") writer.tag(8, WireType.LengthDelimited).string(message.password);
      /* proto.edox.access.PersonalData personal_data = 9; */

      if (message.personalData) PersonalData.internalBinaryWrite(message.personalData, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RegistrationRequest$Type;
}(MessageType);
/**
 * @deprecated
 * @generated MessageType for protobuf message grpc.edox.access.RegistrationRequest
 */


export var RegistrationRequest = new RegistrationRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RegistrationResponse$Type = /*#__PURE__*/function (_MessageType9) {
  _inherits(RegistrationResponse$Type, _MessageType9);

  var _super9 = _createSuper(RegistrationResponse$Type);

  function RegistrationResponse$Type() {
    _classCallCheck(this, RegistrationResponse$Type);

    return _super9.call(this, "grpc.edox.access.RegistrationResponse", [{
      no: 1,
      name: "user_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "masked_phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "auth_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }]);
  }

  _createClass(RegistrationResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        userId: "",
        maskedPhone: "",
        authId: "0"
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag17 = reader.tag(),
            _reader$tag18 = _slicedToArray(_reader$tag17, 2),
            fieldNo = _reader$tag18[0],
            wireType = _reader$tag18[1];

        switch (fieldNo) {
          case
          /* string user_id */
          1:
            message.userId = reader.string();
            break;

          case
          /* string masked_phone */
          2:
            message.maskedPhone = reader.string();
            break;

          case
          /* uint64 auth_id */
          3:
            message.authId = reader.uint64().toString();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string user_id = 1; */
      if (message.userId !== "") writer.tag(1, WireType.LengthDelimited).string(message.userId);
      /* string masked_phone = 2; */

      if (message.maskedPhone !== "") writer.tag(2, WireType.LengthDelimited).string(message.maskedPhone);
      /* uint64 auth_id = 3; */

      if (message.authId !== "0") writer.tag(3, WireType.Varint).uint64(message.authId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RegistrationResponse$Type;
}(MessageType);
/**
 * @deprecated
 * @generated MessageType for protobuf message grpc.edox.access.RegistrationResponse
 */


export var RegistrationResponse = new RegistrationResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RegisterAccountRequest$Type = /*#__PURE__*/function (_MessageType10) {
  _inherits(RegisterAccountRequest$Type, _MessageType10);

  var _super10 = _createSuper(RegisterAccountRequest$Type);

  function RegisterAccountRequest$Type() {
    _classCallCheck(this, RegisterAccountRequest$Type);

    return _super10.call(this, "grpc.edox.access.RegisterAccountRequest", [{
      no: 1,
      name: "phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "email",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "password",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "personal_data",
      kind: "message",
      T: function T() {
        return PersonalData;
      }
    }, {
      no: 5,
      name: "citizenship_country_id",
      kind: "scalar",
      T: 13
      /*ScalarType.UINT32*/

    }]);
  }

  _createClass(RegisterAccountRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        phone: "",
        email: "",
        password: "",
        citizenshipCountryId: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag19 = reader.tag(),
            _reader$tag20 = _slicedToArray(_reader$tag19, 2),
            fieldNo = _reader$tag20[0],
            wireType = _reader$tag20[1];

        switch (fieldNo) {
          case
          /* string phone */
          1:
            message.phone = reader.string();
            break;

          case
          /* string email */
          2:
            message.email = reader.string();
            break;

          case
          /* string password */
          3:
            message.password = reader.string();
            break;

          case
          /* proto.edox.access.PersonalData personal_data */
          4:
            message.personalData = PersonalData.internalBinaryRead(reader, reader.uint32(), options, message.personalData);
            break;

          case
          /* uint32 citizenship_country_id */
          5:
            message.citizenshipCountryId = reader.uint32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string phone = 1; */
      if (message.phone !== "") writer.tag(1, WireType.LengthDelimited).string(message.phone);
      /* string email = 2; */

      if (message.email !== "") writer.tag(2, WireType.LengthDelimited).string(message.email);
      /* string password = 3; */

      if (message.password !== "") writer.tag(3, WireType.LengthDelimited).string(message.password);
      /* proto.edox.access.PersonalData personal_data = 4; */

      if (message.personalData) PersonalData.internalBinaryWrite(message.personalData, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      /* uint32 citizenship_country_id = 5; */

      if (message.citizenshipCountryId !== 0) writer.tag(5, WireType.Varint).uint32(message.citizenshipCountryId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RegisterAccountRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.RegisterAccountRequest
 */


export var RegisterAccountRequest = new RegisterAccountRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RegisterAccountResponse$Type = /*#__PURE__*/function (_MessageType11) {
  _inherits(RegisterAccountResponse$Type, _MessageType11);

  var _super11 = _createSuper(RegisterAccountResponse$Type);

  function RegisterAccountResponse$Type() {
    _classCallCheck(this, RegisterAccountResponse$Type);

    return _super11.call(this, "grpc.edox.access.RegisterAccountResponse", [{
      no: 1,
      name: "account",
      kind: "message",
      T: function T() {
        return UserAccount;
      }
    }]);
  }

  _createClass(RegisterAccountResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag21 = reader.tag(),
            _reader$tag22 = _slicedToArray(_reader$tag21, 2),
            fieldNo = _reader$tag22[0],
            wireType = _reader$tag22[1];

        switch (fieldNo) {
          case
          /* proto.edox.access.UserAccount account */
          1:
            message.account = UserAccount.internalBinaryRead(reader, reader.uint32(), options, message.account);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.edox.access.UserAccount account = 1; */
      if (message.account) UserAccount.internalBinaryWrite(message.account, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RegisterAccountResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.RegisterAccountResponse
 */


export var RegisterAccountResponse = new RegisterAccountResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ConfirmRegistrationRequest$Type = /*#__PURE__*/function (_MessageType12) {
  _inherits(ConfirmRegistrationRequest$Type, _MessageType12);

  var _super12 = _createSuper(ConfirmRegistrationRequest$Type);

  function ConfirmRegistrationRequest$Type() {
    _classCallCheck(this, ConfirmRegistrationRequest$Type);

    return _super12.call(this, "grpc.edox.access.ConfirmRegistrationRequest", [{
      no: 1,
      name: "user_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "code",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "auth_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }]);
  }

  _createClass(ConfirmRegistrationRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        userId: "",
        code: "",
        authId: "0"
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag23 = reader.tag(),
            _reader$tag24 = _slicedToArray(_reader$tag23, 2),
            fieldNo = _reader$tag24[0],
            wireType = _reader$tag24[1];

        switch (fieldNo) {
          case
          /* string user_id = 1 [deprecated = true];*/
          1:
            message.userId = reader.string();
            break;

          case
          /* string code */
          2:
            message.code = reader.string();
            break;

          case
          /* uint64 auth_id */
          3:
            message.authId = reader.uint64().toString();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string user_id = 1 [deprecated = true]; */
      if (message.userId !== "") writer.tag(1, WireType.LengthDelimited).string(message.userId);
      /* string code = 2; */

      if (message.code !== "") writer.tag(2, WireType.LengthDelimited).string(message.code);
      /* uint64 auth_id = 3; */

      if (message.authId !== "0") writer.tag(3, WireType.Varint).uint64(message.authId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ConfirmRegistrationRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.ConfirmRegistrationRequest
 */


export var ConfirmRegistrationRequest = new ConfirmRegistrationRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RenewRegistrationConfirmationRequest$Type = /*#__PURE__*/function (_MessageType13) {
  _inherits(RenewRegistrationConfirmationRequest$Type, _MessageType13);

  var _super13 = _createSuper(RenewRegistrationConfirmationRequest$Type);

  function RenewRegistrationConfirmationRequest$Type() {
    _classCallCheck(this, RenewRegistrationConfirmationRequest$Type);

    return _super13.call(this, "grpc.edox.access.RenewRegistrationConfirmationRequest", [{
      no: 1,
      name: "user_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(RenewRegistrationConfirmationRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        userId: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag25 = reader.tag(),
            _reader$tag26 = _slicedToArray(_reader$tag25, 2),
            fieldNo = _reader$tag26[0],
            wireType = _reader$tag26[1];

        switch (fieldNo) {
          case
          /* string user_id */
          1:
            message.userId = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string user_id = 1; */
      if (message.userId !== "") writer.tag(1, WireType.LengthDelimited).string(message.userId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RenewRegistrationConfirmationRequest$Type;
}(MessageType);
/**
 * @deprecated
 * @generated MessageType for protobuf message grpc.edox.access.RenewRegistrationConfirmationRequest
 */


export var RenewRegistrationConfirmationRequest = new RenewRegistrationConfirmationRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RenewRegistrationConfirmationResponse$Type = /*#__PURE__*/function (_MessageType14) {
  _inherits(RenewRegistrationConfirmationResponse$Type, _MessageType14);

  var _super14 = _createSuper(RenewRegistrationConfirmationResponse$Type);

  function RenewRegistrationConfirmationResponse$Type() {
    _classCallCheck(this, RenewRegistrationConfirmationResponse$Type);

    return _super14.call(this, "grpc.edox.access.RenewRegistrationConfirmationResponse", [{
      no: 1,
      name: "masked_phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(RenewRegistrationConfirmationResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        maskedPhone: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag27 = reader.tag(),
            _reader$tag28 = _slicedToArray(_reader$tag27, 2),
            fieldNo = _reader$tag28[0],
            wireType = _reader$tag28[1];

        switch (fieldNo) {
          case
          /* string masked_phone */
          1:
            message.maskedPhone = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string masked_phone = 1; */
      if (message.maskedPhone !== "") writer.tag(1, WireType.LengthDelimited).string(message.maskedPhone);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RenewRegistrationConfirmationResponse$Type;
}(MessageType);
/**
 * @deprecated
 * @generated MessageType for protobuf message grpc.edox.access.RenewRegistrationConfirmationResponse
 */


export var RenewRegistrationConfirmationResponse = new RenewRegistrationConfirmationResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RequestRegistrationConfirmationRequest$Type = /*#__PURE__*/function (_MessageType15) {
  _inherits(RequestRegistrationConfirmationRequest$Type, _MessageType15);

  var _super15 = _createSuper(RequestRegistrationConfirmationRequest$Type);

  function RequestRegistrationConfirmationRequest$Type() {
    _classCallCheck(this, RequestRegistrationConfirmationRequest$Type);

    return _super15.call(this, "grpc.edox.access.RequestRegistrationConfirmationRequest", [{
      no: 1,
      name: "auth_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }]);
  }

  _createClass(RequestRegistrationConfirmationRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        authId: "0"
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag29 = reader.tag(),
            _reader$tag30 = _slicedToArray(_reader$tag29, 2),
            fieldNo = _reader$tag30[0],
            wireType = _reader$tag30[1];

        switch (fieldNo) {
          case
          /* uint64 auth_id */
          1:
            message.authId = reader.uint64().toString();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* uint64 auth_id = 1; */
      if (message.authId !== "0") writer.tag(1, WireType.Varint).uint64(message.authId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RequestRegistrationConfirmationRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.RequestRegistrationConfirmationRequest
 */


export var RequestRegistrationConfirmationRequest = new RequestRegistrationConfirmationRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RequestRegistrationConfirmationResponse$Type = /*#__PURE__*/function (_MessageType16) {
  _inherits(RequestRegistrationConfirmationResponse$Type, _MessageType16);

  var _super16 = _createSuper(RequestRegistrationConfirmationResponse$Type);

  function RequestRegistrationConfirmationResponse$Type() {
    _classCallCheck(this, RequestRegistrationConfirmationResponse$Type);

    return _super16.call(this, "grpc.edox.access.RequestRegistrationConfirmationResponse", [{
      no: 1,
      name: "masked_phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "code_number",
      kind: "scalar",
      T: 13
      /*ScalarType.UINT32*/

    }, {
      no: 3,
      name: "code_length",
      kind: "scalar",
      T: 13
      /*ScalarType.UINT32*/

    }, {
      no: 4,
      name: "expiration_time",
      kind: "message",
      T: function T() {
        return Timestamp;
      }
    }]);
  }

  _createClass(RequestRegistrationConfirmationResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        maskedPhone: "",
        codeNumber: 0,
        codeLength: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag31 = reader.tag(),
            _reader$tag32 = _slicedToArray(_reader$tag31, 2),
            fieldNo = _reader$tag32[0],
            wireType = _reader$tag32[1];

        switch (fieldNo) {
          case
          /* string masked_phone */
          1:
            message.maskedPhone = reader.string();
            break;

          case
          /* uint32 code_number */
          2:
            message.codeNumber = reader.uint32();
            break;

          case
          /* uint32 code_length */
          3:
            message.codeLength = reader.uint32();
            break;

          case
          /* google.protobuf.Timestamp expiration_time */
          4:
            message.expirationTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expirationTime);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string masked_phone = 1; */
      if (message.maskedPhone !== "") writer.tag(1, WireType.LengthDelimited).string(message.maskedPhone);
      /* uint32 code_number = 2; */

      if (message.codeNumber !== 0) writer.tag(2, WireType.Varint).uint32(message.codeNumber);
      /* uint32 code_length = 3; */

      if (message.codeLength !== 0) writer.tag(3, WireType.Varint).uint32(message.codeLength);
      /* google.protobuf.Timestamp expiration_time = 4; */

      if (message.expirationTime) Timestamp.internalBinaryWrite(message.expirationTime, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RequestRegistrationConfirmationResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.RequestRegistrationConfirmationResponse
 */


export var RequestRegistrationConfirmationResponse = new RequestRegistrationConfirmationResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RequestEmailConfirmationRequest$Type = /*#__PURE__*/function (_MessageType17) {
  _inherits(RequestEmailConfirmationRequest$Type, _MessageType17);

  var _super17 = _createSuper(RequestEmailConfirmationRequest$Type);

  function RequestEmailConfirmationRequest$Type() {
    _classCallCheck(this, RequestEmailConfirmationRequest$Type);

    return _super17.call(this, "grpc.edox.access.RequestEmailConfirmationRequest", [{
      no: 1,
      name: "auth_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }, {
      no: 2,
      name: "email",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(RequestEmailConfirmationRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        authId: "0",
        email: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag33 = reader.tag(),
            _reader$tag34 = _slicedToArray(_reader$tag33, 2),
            fieldNo = _reader$tag34[0],
            wireType = _reader$tag34[1];

        switch (fieldNo) {
          case
          /* uint64 auth_id */
          1:
            message.authId = reader.uint64().toString();
            break;

          case
          /* string email */
          2:
            message.email = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* uint64 auth_id = 1; */
      if (message.authId !== "0") writer.tag(1, WireType.Varint).uint64(message.authId);
      /* string email = 2; */

      if (message.email !== "") writer.tag(2, WireType.LengthDelimited).string(message.email);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RequestEmailConfirmationRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.RequestEmailConfirmationRequest
 */


export var RequestEmailConfirmationRequest = new RequestEmailConfirmationRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ConfirmEmailRequest$Type = /*#__PURE__*/function (_MessageType18) {
  _inherits(ConfirmEmailRequest$Type, _MessageType18);

  var _super18 = _createSuper(ConfirmEmailRequest$Type);

  function ConfirmEmailRequest$Type() {
    _classCallCheck(this, ConfirmEmailRequest$Type);

    return _super18.call(this, "grpc.edox.access.ConfirmEmailRequest", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(ConfirmEmailRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag35 = reader.tag(),
            _reader$tag36 = _slicedToArray(_reader$tag35, 2),
            fieldNo = _reader$tag36[0],
            wireType = _reader$tag36[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ConfirmEmailRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.ConfirmEmailRequest
 */


export var ConfirmEmailRequest = new ConfirmEmailRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ChangeLoginRequest$Type = /*#__PURE__*/function (_MessageType19) {
  _inherits(ChangeLoginRequest$Type, _MessageType19);

  var _super19 = _createSuper(ChangeLoginRequest$Type);

  function ChangeLoginRequest$Type() {
    _classCallCheck(this, ChangeLoginRequest$Type);

    return _super19.call(this, "grpc.edox.access.ChangeLoginRequest", [{
      no: 1,
      name: "auth_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }, {
      no: 2,
      name: "new_login",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(ChangeLoginRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        authId: "0",
        newLogin: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag37 = reader.tag(),
            _reader$tag38 = _slicedToArray(_reader$tag37, 2),
            fieldNo = _reader$tag38[0],
            wireType = _reader$tag38[1];

        switch (fieldNo) {
          case
          /* uint64 auth_id */
          1:
            message.authId = reader.uint64().toString();
            break;

          case
          /* string new_login */
          2:
            message.newLogin = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* uint64 auth_id = 1; */
      if (message.authId !== "0") writer.tag(1, WireType.Varint).uint64(message.authId);
      /* string new_login = 2; */

      if (message.newLogin !== "") writer.tag(2, WireType.LengthDelimited).string(message.newLogin);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ChangeLoginRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.ChangeLoginRequest
 */


export var ChangeLoginRequest = new ChangeLoginRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var CheckLoginInUseRequest$Type = /*#__PURE__*/function (_MessageType20) {
  _inherits(CheckLoginInUseRequest$Type, _MessageType20);

  var _super20 = _createSuper(CheckLoginInUseRequest$Type);

  function CheckLoginInUseRequest$Type() {
    _classCallCheck(this, CheckLoginInUseRequest$Type);

    return _super20.call(this, "grpc.edox.access.CheckLoginInUseRequest", [{
      no: 1,
      name: "login",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(CheckLoginInUseRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        login: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag39 = reader.tag(),
            _reader$tag40 = _slicedToArray(_reader$tag39, 2),
            fieldNo = _reader$tag40[0],
            wireType = _reader$tag40[1];

        switch (fieldNo) {
          case
          /* string login */
          1:
            message.login = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string login = 1; */
      if (message.login !== "") writer.tag(1, WireType.LengthDelimited).string(message.login);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return CheckLoginInUseRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.CheckLoginInUseRequest
 */


export var CheckLoginInUseRequest = new CheckLoginInUseRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var CheckLoginInUseResponse$Type = /*#__PURE__*/function (_MessageType21) {
  _inherits(CheckLoginInUseResponse$Type, _MessageType21);

  var _super21 = _createSuper(CheckLoginInUseResponse$Type);

  function CheckLoginInUseResponse$Type() {
    _classCallCheck(this, CheckLoginInUseResponse$Type);

    return _super21.call(this, "grpc.edox.access.CheckLoginInUseResponse", [{
      no: 1,
      name: "in_use",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }]);
  }

  _createClass(CheckLoginInUseResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        inUse: false
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag41 = reader.tag(),
            _reader$tag42 = _slicedToArray(_reader$tag41, 2),
            fieldNo = _reader$tag42[0],
            wireType = _reader$tag42[1];

        switch (fieldNo) {
          case
          /* bool in_use */
          1:
            message.inUse = reader.bool();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* bool in_use = 1; */
      if (message.inUse !== false) writer.tag(1, WireType.Varint).bool(message.inUse);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return CheckLoginInUseResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.CheckLoginInUseResponse
 */


export var CheckLoginInUseResponse = new CheckLoginInUseResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RequestRestoreAccessRequest$Type = /*#__PURE__*/function (_MessageType22) {
  _inherits(RequestRestoreAccessRequest$Type, _MessageType22);

  var _super22 = _createSuper(RequestRestoreAccessRequest$Type);

  function RequestRestoreAccessRequest$Type() {
    _classCallCheck(this, RequestRestoreAccessRequest$Type);

    return _super22.call(this, "grpc.edox.access.RequestRestoreAccessRequest", [{
      no: 1,
      name: "user_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "authentication_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }]);
  }

  _createClass(RequestRestoreAccessRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        userId: "",
        authenticationId: "0"
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag43 = reader.tag(),
            _reader$tag44 = _slicedToArray(_reader$tag43, 2),
            fieldNo = _reader$tag44[0],
            wireType = _reader$tag44[1];

        switch (fieldNo) {
          case
          /* string user_id = 1 [deprecated = true];*/
          1:
            message.userId = reader.string();
            break;

          case
          /* uint64 authentication_id */
          2:
            message.authenticationId = reader.uint64().toString();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string user_id = 1 [deprecated = true]; */
      if (message.userId !== "") writer.tag(1, WireType.LengthDelimited).string(message.userId);
      /* uint64 authentication_id = 2; */

      if (message.authenticationId !== "0") writer.tag(2, WireType.Varint).uint64(message.authenticationId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RequestRestoreAccessRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.RequestRestoreAccessRequest
 */


export var RequestRestoreAccessRequest = new RequestRestoreAccessRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var CheckRestoreAccessRequest$Type = /*#__PURE__*/function (_MessageType23) {
  _inherits(CheckRestoreAccessRequest$Type, _MessageType23);

  var _super23 = _createSuper(CheckRestoreAccessRequest$Type);

  function CheckRestoreAccessRequest$Type() {
    _classCallCheck(this, CheckRestoreAccessRequest$Type);

    return _super23.call(this, "grpc.edox.access.CheckRestoreAccessRequest", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(CheckRestoreAccessRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag45 = reader.tag(),
            _reader$tag46 = _slicedToArray(_reader$tag45, 2),
            fieldNo = _reader$tag46[0],
            wireType = _reader$tag46[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return CheckRestoreAccessRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.CheckRestoreAccessRequest
 */


export var CheckRestoreAccessRequest = new CheckRestoreAccessRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ConfirmRestoreAccessRequest$Type = /*#__PURE__*/function (_MessageType24) {
  _inherits(ConfirmRestoreAccessRequest$Type, _MessageType24);

  var _super24 = _createSuper(ConfirmRestoreAccessRequest$Type);

  function ConfirmRestoreAccessRequest$Type() {
    _classCallCheck(this, ConfirmRestoreAccessRequest$Type);

    return _super24.call(this, "grpc.edox.access.ConfirmRestoreAccessRequest", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(ConfirmRestoreAccessRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag47 = reader.tag(),
            _reader$tag48 = _slicedToArray(_reader$tag47, 2),
            fieldNo = _reader$tag48[0],
            wireType = _reader$tag48[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ConfirmRestoreAccessRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.ConfirmRestoreAccessRequest
 */


export var ConfirmRestoreAccessRequest = new ConfirmRestoreAccessRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ConfirmRestoreAccessResponse$Type = /*#__PURE__*/function (_MessageType25) {
  _inherits(ConfirmRestoreAccessResponse$Type, _MessageType25);

  var _super25 = _createSuper(ConfirmRestoreAccessResponse$Type);

  function ConfirmRestoreAccessResponse$Type() {
    _classCallCheck(this, ConfirmRestoreAccessResponse$Type);

    return _super25.call(this, "grpc.edox.access.ConfirmRestoreAccessResponse", [{
      no: 1,
      name: "masked_phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(ConfirmRestoreAccessResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        maskedPhone: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag49 = reader.tag(),
            _reader$tag50 = _slicedToArray(_reader$tag49, 2),
            fieldNo = _reader$tag50[0],
            wireType = _reader$tag50[1];

        switch (fieldNo) {
          case
          /* string masked_phone */
          1:
            message.maskedPhone = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string masked_phone = 1; */
      if (message.maskedPhone !== "") writer.tag(1, WireType.LengthDelimited).string(message.maskedPhone);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ConfirmRestoreAccessResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.ConfirmRestoreAccessResponse
 */


export var ConfirmRestoreAccessResponse = new ConfirmRestoreAccessResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RestoreAccessRequest$Type = /*#__PURE__*/function (_MessageType26) {
  _inherits(RestoreAccessRequest$Type, _MessageType26);

  var _super26 = _createSuper(RestoreAccessRequest$Type);

  function RestoreAccessRequest$Type() {
    _classCallCheck(this, RestoreAccessRequest$Type);

    return _super26.call(this, "grpc.edox.access.RestoreAccessRequest", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "password",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "code",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(RestoreAccessRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: "",
        password: "",
        code: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag51 = reader.tag(),
            _reader$tag52 = _slicedToArray(_reader$tag51, 2),
            fieldNo = _reader$tag52[0],
            wireType = _reader$tag52[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          case
          /* string password */
          2:
            message.password = reader.string();
            break;

          case
          /* string code */
          3:
            message.code = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      /* string password = 2; */

      if (message.password !== "") writer.tag(2, WireType.LengthDelimited).string(message.password);
      /* string code = 3; */

      if (message.code !== "") writer.tag(3, WireType.LengthDelimited).string(message.code);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RestoreAccessRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.RestoreAccessRequest
 */


export var RestoreAccessRequest = new RestoreAccessRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ChangePasswordRequest$Type = /*#__PURE__*/function (_MessageType27) {
  _inherits(ChangePasswordRequest$Type, _MessageType27);

  var _super27 = _createSuper(ChangePasswordRequest$Type);

  function ChangePasswordRequest$Type() {
    _classCallCheck(this, ChangePasswordRequest$Type);

    return _super27.call(this, "grpc.edox.access.ChangePasswordRequest", [{
      no: 1,
      name: "auth_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }, {
      no: 2,
      name: "old_password",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "new_password",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "is_temporary",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }]);
  }

  _createClass(ChangePasswordRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        authId: "0",
        oldPassword: "",
        newPassword: "",
        isTemporary: false
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag53 = reader.tag(),
            _reader$tag54 = _slicedToArray(_reader$tag53, 2),
            fieldNo = _reader$tag54[0],
            wireType = _reader$tag54[1];

        switch (fieldNo) {
          case
          /* uint64 auth_id */
          1:
            message.authId = reader.uint64().toString();
            break;

          case
          /* string old_password */
          2:
            message.oldPassword = reader.string();
            break;

          case
          /* string new_password */
          3:
            message.newPassword = reader.string();
            break;

          case
          /* bool is_temporary */
          4:
            message.isTemporary = reader.bool();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* uint64 auth_id = 1; */
      if (message.authId !== "0") writer.tag(1, WireType.Varint).uint64(message.authId);
      /* string old_password = 2; */

      if (message.oldPassword !== "") writer.tag(2, WireType.LengthDelimited).string(message.oldPassword);
      /* string new_password = 3; */

      if (message.newPassword !== "") writer.tag(3, WireType.LengthDelimited).string(message.newPassword);
      /* bool is_temporary = 4; */

      if (message.isTemporary !== false) writer.tag(4, WireType.Varint).bool(message.isTemporary);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ChangePasswordRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.ChangePasswordRequest
 */


export var ChangePasswordRequest = new ChangePasswordRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var VerifyAccountRequest$Type = /*#__PURE__*/function (_MessageType28) {
  _inherits(VerifyAccountRequest$Type, _MessageType28);

  var _super28 = _createSuper(VerifyAccountRequest$Type);

  function VerifyAccountRequest$Type() {
    _classCallCheck(this, VerifyAccountRequest$Type);

    return _super28.call(this, "grpc.edox.access.VerifyAccountRequest", []);
  }

  _createClass(VerifyAccountRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      return target !== null && target !== void 0 ? target : this.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return VerifyAccountRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.VerifyAccountRequest
 */


export var VerifyAccountRequest = new VerifyAccountRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var VerifyAccountResponse$Type = /*#__PURE__*/function (_MessageType29) {
  _inherits(VerifyAccountResponse$Type, _MessageType29);

  var _super29 = _createSuper(VerifyAccountResponse$Type);

  function VerifyAccountResponse$Type() {
    _classCallCheck(this, VerifyAccountResponse$Type);

    return _super29.call(this, "grpc.edox.access.VerifyAccountResponse", []);
  }

  _createClass(VerifyAccountResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      return target !== null && target !== void 0 ? target : this.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return VerifyAccountResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.VerifyAccountResponse
 */


export var VerifyAccountResponse = new VerifyAccountResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetUserAccountInfoRequest$Type = /*#__PURE__*/function (_MessageType30) {
  _inherits(GetUserAccountInfoRequest$Type, _MessageType30);

  var _super30 = _createSuper(GetUserAccountInfoRequest$Type);

  function GetUserAccountInfoRequest$Type() {
    _classCallCheck(this, GetUserAccountInfoRequest$Type);

    return _super30.call(this, "grpc.edox.access.GetUserAccountInfoRequest", []);
  }

  _createClass(GetUserAccountInfoRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      return target !== null && target !== void 0 ? target : this.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetUserAccountInfoRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.GetUserAccountInfoRequest
 */


export var GetUserAccountInfoRequest = new GetUserAccountInfoRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetUserAccountInfoResponse$Type = /*#__PURE__*/function (_MessageType31) {
  _inherits(GetUserAccountInfoResponse$Type, _MessageType31);

  var _super31 = _createSuper(GetUserAccountInfoResponse$Type);

  function GetUserAccountInfoResponse$Type() {
    _classCallCheck(this, GetUserAccountInfoResponse$Type);

    return _super31.call(this, "grpc.edox.access.GetUserAccountInfoResponse", [{
      no: 1,
      name: "authentication_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }, {
      no: 2,
      name: "login",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "password_change_date",
      kind: "message",
      T: function T() {
        return Timestamp;
      }
    }]);
  }

  _createClass(GetUserAccountInfoResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        authenticationId: "0",
        login: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag55 = reader.tag(),
            _reader$tag56 = _slicedToArray(_reader$tag55, 2),
            fieldNo = _reader$tag56[0],
            wireType = _reader$tag56[1];

        switch (fieldNo) {
          case
          /* uint64 authentication_id */
          1:
            message.authenticationId = reader.uint64().toString();
            break;

          case
          /* string login */
          2:
            message.login = reader.string();
            break;

          case
          /* google.protobuf.Timestamp password_change_date */
          3:
            message.passwordChangeDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.passwordChangeDate);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* uint64 authentication_id = 1; */
      if (message.authenticationId !== "0") writer.tag(1, WireType.Varint).uint64(message.authenticationId);
      /* string login = 2; */

      if (message.login !== "") writer.tag(2, WireType.LengthDelimited).string(message.login);
      /* google.protobuf.Timestamp password_change_date = 3; */

      if (message.passwordChangeDate) Timestamp.internalBinaryWrite(message.passwordChangeDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetUserAccountInfoResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.edox.access.GetUserAccountInfoResponse
 */


export var GetUserAccountInfoResponse = new GetUserAccountInfoResponse$Type();
/**
 * @generated ServiceType for protobuf service grpc.edox.access.AccessApi
 */

export var AccessApi = new ServiceType("grpc.edox.access.AccessApi", [{
  name: "GetRegistrationInfo",
  options: {},
  I: GetRegistrationInfoRequest,
  O: GetRegistrationInfoResponse
}, {
  name: "RequestRestoreAccess",
  options: {},
  I: RequestRestoreAccessRequest,
  O: Empty
}, {
  name: "CheckRestoreAccess",
  options: {},
  I: CheckRestoreAccessRequest,
  O: Empty
}, {
  name: "ConfirmRestoreAccess",
  options: {},
  I: ConfirmRestoreAccessRequest,
  O: ConfirmRestoreAccessResponse
}, {
  name: "RestoreAccess",
  options: {},
  I: RestoreAccessRequest,
  O: Empty
}, {
  name: "CheckRegistration",
  options: {},
  I: CheckRegistrationRequest,
  O: CheckRegistrationResponse
}, {
  name: "CheckAccountRegistration",
  options: {},
  I: CheckAccountRegistrationRequest,
  O: CheckAccountRegistrationResponse
}, {
  name: "Register",
  options: {},
  I: RegistrationRequest,
  O: RegistrationResponse
}, {
  name: "RegisterAccount",
  options: {},
  I: RegisterAccountRequest,
  O: RegisterAccountResponse
}, {
  name: "ConfirmRegistration",
  options: {},
  I: ConfirmRegistrationRequest,
  O: Empty
}, {
  name: "RenewRegistrationConfirmation",
  options: {},
  I: RenewRegistrationConfirmationRequest,
  O: RenewRegistrationConfirmationResponse
}, {
  name: "RequestRegistrationConfirmation",
  options: {},
  I: RequestRegistrationConfirmationRequest,
  O: RequestRegistrationConfirmationResponse
}, {
  name: "RequestEmailConfirmation",
  options: {},
  I: RequestEmailConfirmationRequest,
  O: Empty
}, {
  name: "ConfirmEmail",
  options: {},
  I: ConfirmEmailRequest,
  O: Empty
}, {
  name: "ChangeLogin",
  options: {},
  I: ChangeLoginRequest,
  O: Empty
}, {
  name: "CheckLoginInUse",
  options: {},
  I: CheckLoginInUseRequest,
  O: CheckLoginInUseResponse
}, {
  name: "ChangePassword",
  options: {},
  I: ChangePasswordRequest,
  O: Empty
}, {
  name: "VerifyAccount",
  options: {},
  I: VerifyAccountRequest,
  O: VerifyAccountResponse
}, {
  name: "GetUserAccountInfo",
  options: {},
  I: GetUserAccountInfoRequest,
  O: GetUserAccountInfoResponse
}]);